export var setStatic = function (key, value) { return function (BaseComponent) {
    BaseComponent[key] = value;
    return BaseComponent;
}; };
